import { createSlice } from "@reduxjs/toolkit";

import { ROLE_ASSET_MANAGER } from "../../../Utils/constant";
import { getMoment } from "../../../Utils/dateTimeHelper";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  assetForEdit: {
    id: undefined,
    name: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
  stateData: {},
  selectedTab: 0,
  selectedTabName: null,
  selectedFinanceTab: 0,
  chatList: [],
  chatCount: 0,
  chatRoomId: null,
  chatRoomExist: null,
  internalChatRoomExist: null,
  isInternalChatRoomExist: false,
  isUsersAddedInChat: false,
  participantId: null,
  isAssetManager: false,
  bidCount: 0,
  bidList: [],
  chatRoomList: [],
  accessData: {
    button: false,
    chatWindow: false,
    addUser: false,
    chatList: false,
  },
  assetDetail: null,
  openMakeOffer: null,
  acceptOffer: null,
  addAssetInWishlist: false,
  addAssetInCustomList: false,
  setEventTarget: null,
  setIsSignupSuccess: false,
  showStickyHeader: false,
  lastBid: null,
  isAssetinWishList: null,
  isCancelled: false,
  isDecline: false,
  timerObj: [],
  selectedOffer: null,
  isSeller: false,
  offerdPrice: null,
  isFirstOfferAccTOAP: false,
  lastOffer: null,
  isMergeModelopen: false,
  isAssetInList: false,
  assetCList: null,
  isFocusOnMsgField: false,
  showArchiveDialog: false,
  showDeleteDialog: false,
  assetId: undefined,
  assetTitle: undefined,
  assetEN: undefined,
  isAssetPurchased: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const assetSlice = createSlice({
  name: "assets",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // category loader
    assetListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    assetList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    setFocusOnMsgField: (state, action) => {
      state.isFocusOnMsgField = action.payload;
    },
    loadAssetForEdit: (state, action) => {
      state.assetForEdit = action.payload;
    },
    setMergePopupOpen: (state, action) => {
      state.isMergeModelopen = action.payload;
    },
    isAssetPurchased: (state, action) => {
      state.isAssetPurchased = action.payload;
    },
    loadAssetMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
    loadState: (state, action) => {
      state.stateData = action.payload;
    },
    setAssetInList: (state, action) => {
      state.isAssetInList = action.payload;
    },
    setAssetCList: (state, action) => {
      state.assetCList = action.payload;
    },
    setIsSeller: (state, action) => {
      state.isSeller = action.payload;
    },
    setOfferedPrice: (state, action) => {
      state.offerdPrice = action.payload;
    },
    setIsOfferForSeller: (state, action) => {
      if (state.lastBid) {
        state.lastBid.isOfferForSeller = action.payload;
      }
    },
    setIsOfferAcctoAP: (state, action) => {
      state.isFirstOfferAccTOAP = action.payload;
    },
    setTab: (state, action) => {
      const { tabNo, tabName } = action.payload;

      state.selectedTab = tabNo;
      state.selectedTabName = tabName;
    },
    setAssetinWishList: (state, action) => {
      state.isAssetinWishList = action.payload;
    },
    chatList: (state, action) => {
      const { result, count, lastOffer } = action.payload;

      state.chatCount = count;
      state.chatList = result;
      state.lastOffer = lastOffer;
    },
    updateChatList: (state, action) => {
      const payload = action.payload;

      state.chatList = [...state.chatList, payload];
      if (payload.isOffer) {
        state.lastOffer = payload;
      }
    },
    setChatRoomId: (state, action) => {
      state.chatRoomId = action.payload;
    },
    setAssetDetail: (state, action) => {
      state.assetDetail = action.payload;
    },
    setIsAssetManager: (state, action) => {
      state.isAssetManager = action.payload;
    },
    setLastBid: (state, action) => {
      if (action.payload) {
        state.lastBid = action.payload;
      } else state.lastBid = null;
    },
    setIsAccepted: (state, action) => {
      if (state.lastBid === null) {
        let tempVal = { isAccept: action.payload };

        state.lastBid = tempVal;
      } else {
        state.lastBid.isAccept = action.payload;
      }

      if (state.setIsSignupSuccess) state.setIsSignupSuccess = false;
    },
    setIsSignupSuccessfull: (state, action) => {
      state.setIsSignupSuccess = action.payload;
    },
    setOpenOfferModel: (state, actionTemp) => {
      const { action, isShown, actionTempVal } = actionTemp.payload;

      state.openMakeOffer = {
        action: action,
        isShown: isShown,
        actionTempVal: actionTempVal,
      };
    },
    setAcceptOfferModel: (state, actionTemp) => {
      const { action, isShown } = actionTemp.payload;

      state.acceptOffer = { action: action, isShown: isShown };
    },
    chatRoomExist: (state, action) => {
      state.chatRoomExist = action.payload;
    },
    selectOfferObj: (state, action) => {
      state.selectedOffer = action.payload;
    },
    bidlist: (state, action) => {
      const { tempArr, count } = action.payload;

      state.bidCount = count;
      state.bidList = tempArr;
    },
    updateBidList: (state, action) => {
      const payload = action.payload;

      let tempVal = handleLastItem(payload, state.lastBid, state.timerObj);

      state.bidList = [...state.bidList, tempVal];
      state.lastBid = tempVal;
    },
    updateLastBidList: (state, action) => {
      const payload = action.payload;

      if (state.bidList && state.bidList.length > 0) {
        const index = state.bidList.length - 1;

        state.bidList[index] = payload;
        state.lastBid = state.bidList[index];
      }
    },
    updateSellerBidList: (state, action) => {
      const { data } = action.payload;

      let tempVal = handleLastItem(data, state.lastBid, state.timerObj);
      if (tempVal != null) {
        state.bidList = [...state.bidList, tempVal];
        state.lastBid = tempVal;
      }
    },
    chatRoomList: (state, action) => {
      const payload = action.payload;

      state.chatRoomList = payload;
    },
    updateChatListInObj: (state, action) => {
      const payload = action.payload;

      state.chatList = payload;
    },
    setAccessData: (state, action) => {
      const payload = action.payload;

      state.accessData = payload;
    },
    internalChatRoomExist: (state, action) => {
      const { isInternalChatRoomExist, internalChatRoomExist } = action.payload;

      state.isInternalChatRoomExist = isInternalChatRoomExist;
      state.internalChatRoomExist = internalChatRoomExist;
    },
    setIsUsersAddedInChat: (state, action) => {
      state.isUsersAddedInChat = action.payload;
    },
    setParticipantId: (state, action) => {
      state.participantId = action.payload;
    },
    addAssetInWishlist: (state, action) => {
      state.addAssetInWishlist = action.payload;
    },
    addAssetInCustomList: (state, action) => {
      state.addAssetInCustomList = action.payload;
    },
    setEventTarget: (state, action) => {
      state.setEventTarget = action.payload;
    },
    showStickyHeader: (state, action) => {
      state.showStickyHeader = action.payload;
    },
    setIsCancelledOffer: (state, action) => {
      state.isCancelled = action.payload;
    },
    setIsDeclineOffer: (state, action) => {
      state.isDecline = action.payload;
    },
    setIsAcceptedStatus: (state, action) => {
      if (!state.lastBid) {
        let tempVal = { isAccepted: action.payload };

        state.lastBid = tempVal;
      } else {
        if (action.payload) {
          let tempVal = setAcceptTimerExpire(state.lastBid, state.timerObj);

          state.lastBid.isAcceptTimerExpire = tempVal;
        }

        state.lastBid.isAccept = action.payload;
      }
    },
    updateTimerStatus: (state, action) => {
      if (state.bidList.length > 0) {
        state.bidList[state.bidList.length - 1].isBuyerTimerExpires =
          action.payload;
        state.bidList[state.bidList.length - 1].isAMTimerExpires =
          action.payload;
        if (
          state.lastBid &&
          (!state.lastBid?.isBuyerTimerExpires ||
            !state.lastBid?.isAMTimerExpires ||
            action.payload)
        ) {
          state.lastBid.isBuyerTimerExpires = action.payload;
          state.lastBid.isAMTimerExpires = action.payload;
          if (state.lastBid.isAccept || !state.lastBid.isAcceptTimerExpire) {
            if (action.payload)
              state.lastBid.isAcceptTimerExpire = action.payload;
            else {
              let tempVal = setAcceptTimerExpire(state.lastBid, state.timerObj);

              state.lastBid.isAcceptTimerExpire = tempVal;
            }
          }
        }
      }
    },
    setTimerObj: (state, action) => {
      const payload = action.payload;

      if (payload && payload.length > 0) {
        var tempArr = [];

        for (let i = 0; i < payload.length; i++) {
          let tempObj = splitTime(payload[i].format);

          tempArr.push({
            day: tempObj.day,
            hour: tempObj.hour,
            min: tempObj.min,
            key: payload[i].key,
          });
        }

        if (tempArr && tempArr.length > 0) {
          state.timerObj = tempArr;
        }
      }
    },
    setDeleteDialogData: (state, action) => {
      const { id, title } = action.payload;

      state.assetId = id;
      state.assetTitle = title;
      state.showDeleteDialog = !state.showDeleteDialog;
    },
    setArchiveDialogData: (state, action) => {
      const { id, title } = action.payload;

      state.assetId = id;
      state.assetTitle = title;
      state.showArchiveDialog = !state.showArchiveDialog;
    },
  },
});

const handleLastItem = (item, lastBid, timerObj) => {
  if (item) {
    if (item?.createdBy?.roles[0]?.key === ROLE_ASSET_MANAGER) {
      item.lastBidByAM = item.bidAmount;
      item.isLastBidByAM = true;
    } else {
      item.lastBidByAM = 0;
      item.isLastBidByAM = false;
    }

    item.isBuyerTimerExpires = false;
    item.isAMTimerExpires = false;
    if (lastBid) {
      let tempObj = lastBid;

      if (tempObj.isAccept) {
        let tempVal = setAcceptTimerExpire(item, timerObj);

        item.isAcceptTimerExpire = tempVal;
      }
    }
  }

  return item;
};

function splitTime(input) {
  var split_time = input.split(":");
  var Days;
  var Hours;
  var Minutes;

  if (split_time.length > 0) {
    if (split_time[0]) {
      Days = split_time[0];
      if (Days.startsWith("0")) {
        while (Days.length === 2) {
          Days = Days.charAt(1);
        }
      }
    } else Days = "00";
    if (split_time[1]) {
      Hours = split_time[1];
      if (Hours.startsWith("0")) {
        while (Hours.length === 2) {
          Hours = Hours.charAt(1);
        }
      }
    } else Hours = "00";
    if (split_time[2]) {
      Minutes = split_time[2];
      if (Minutes.startsWith("0")) {
        while (Minutes.length === 2) {
          Minutes = Minutes.charAt(1);
        }
      }
    } else Minutes = "00";
  }

  return { day: Days, hour: Hours, min: Minutes };
}

const setAcceptTimerExpire = (payload, timerObj) => {
  var futureDate = getMoment(Number(payload.expiredTimeStamp));
  var today = getMoment();

  if (today.isSameOrAfter(futureDate)) return true;
  else return false;
};
